import CardTravelIcon from '@mui/icons-material/CardTravel';
import { SystemScreen } from '../../components/alliance/system-screen';

/** The trips list is empty: nothing is wrong, so there's no action */
export function TripsNotFound() {
  return (
    <SystemScreen
      layout="inline"
      tone="neutral"
      icon={<CardTravelIcon />}
      title="There are currently no upcoming trips"
      body={<p>Please check back soon!</p>}
    />
  );
}
